import styled from 'styled-components';

export const TopCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  background-color: #fff;

  .top-card-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .top-card-header-title {
    overflow: hidden;
    color: var(--Theme-2-900, #1d426b);
    text-overflow: ellipsis;
    font-family: Mulish;
    font-size: 27px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 40.5px */
  }

  .top-card-body {
    font-family: Mulish;
    font-size: 12.5px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 18.75px */
    margin-top: 14px;
  }

  .cta-container {
    display: flex;
    flex-direction: row;
    gap: 12px;

    .divider {
      height: 32px;
      width: 1px;
      background-color: #e2e8f0;
    }
  }

  .top-card-body-container {
    .top-card-body-tabs {
      margin-top: 18px;
      .chakra-tabs {
        padding-top: 0px;
        .chakra-tabs__tab:nth-child(1) {
          display: none;
        }
      }
    }
  }
`;

export const AnalyticsTabContainer = styled.div`
  display: flex;
  flex-direction: column;

  .incidents-title {
    color: var(--Theme-2-700, #627c98);
    /* 1440 Text/sm - extrabold */
    font-family: Mulish;
    font-size: 12.5px;
    font-style: normal;
    text-transform: uppercase;
    font-weight: 800;
    line-height: 150%; /* 18.75px */
  }

  .incidents-value {
    color: #35577b;

    /* 1440 Text/4xl - regular */
    font-family: Mulish;
    font-size: 32.5px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 48.75px */

    margin-top: 24px;
    margin-bottom: 24px;
  }

  .incidents-delta {
    /* 1440 Text/sm - regular */
    font-family: Mulish;
    font-size: 12.5px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 18.75px */
  }

  .incidents-delta-positive {
    color: var(--Status-Page-and-Component-Green, #209628);
  }

  .incidents-delta-negative {
    color: var(--Status-Page-and-Component-Red, #e03f3f);
  }
`;
